class CareersReviews extends HTMLElement {
    constructor() {
        super();
        this.swiperEl = this;
        this.isAutoplay = this.dataset.isAutoplay === 'true';
        this.autoplaySpeed = +this.dataset.autoplaySpeed;
        this.dynamicBullets = +this.dataset.dynamicBullets;
        this.paginationEl = this.querySelector('.careers-reviews-pagination');
        this.slidePrev = this.querySelector('.careers-reviews-prev');
        this.slideNext = this.querySelector('.careers-reviews-next');
    }

    initSwiper() {
      const autoplay = this.isAutoplay ? { 
        delay: this.autoplaySpeed * 1000, 
        disableOnInteraction: false 
      } : false;

        if (typeof Swiper !== 'undefined') {
            this.swiper = new Swiper(this.swiperEl, {
                slidesPerView: 1,
                autoplay,
                spaceBetween: 16,
                pagination: {
                    el: this.paginationEl,
                    clickable: true,
                    dynamicBullets: true,
                    dynamicMainBullets: this.dynamicBullets
                },
                navigation: {
                  prevEl: this.slidePrev,
                  nextEl: this.slideNext
                },
                breakpoints: {
                  750: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                  },
                  1025: {
                    slidesPerView: 'auto',
                    spaceBetween: 20,
                  },
                },
            });
        }
    }

    connectedCallback() {
        this.initSwiper();
    }
}

if (!customElements.get('careers-reviews')) {
    customElements.define('careers-reviews', CareersReviews);
}